import ccEcharts from '@/components/common/echarts/echarts-base.vue';
import echarts from 'echarts';

export default {
    name: 'bar-echarts',
    components: {ccEcharts},
    props: {
        id: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default() {
                return [];
            }
        },
        rotate:{
            type:Number,
            default:0
        },
        axisFont:{
            type:Number,
            default:18
        },
        labelFont:{
            type:Number,
            default:16
        }
    },
    watch: {
        'data': {
            deep: true,
            handler(val) {
                this.echartsData = val;
                this.initOptions();
            }
        }
    },
    data() {
        return {
            echartsData: this.data,
            options: {
                grid: {
                    top: '15%',
                    bottom: '30%',
                    left:80,
                    right:40
                },
                xAxis: {
                    data: [],
                    axisTick: {show: false},
                    axisLine: {show: false},
                    axisLabel: {
                        interval:0,
                        show: true,
                        margin: this.rotate > 0 ? 60 : 50,
                        align: 'center',
                        textStyle: {
                            fontSize: 16,
                            color: '#40444d'
                        },
                        rotate:this.rotate
                    }
                },
                yAxis: {
                    position:'left',
                    splitLine: {show: false},
                    axisTick: {show: false},
                    axisLine: {show: false},
                    axisLabel: {
                        show: true,
                        margin: 0,
                        interval: 0,
                        min: 0,
                        verticalAlign:'top',
                        align: 'center',
                        textStyle: {
                            fontSize: this.axisFont,
                            color: '#40444d'
                        }
                    },
                    offset:40
                },
                series: [{
                    name: 'top',
                    type: 'pictorialBar',
                    symbolSize: [26, 10],
                    symbolOffset: [0, -5],
                    z: 18,
                    itemStyle: {normal: {color: '#005fcf'}},
                    label: {
                        show: true,
                        position: 'top',
                        fontSize: this.labelFont
                    },
                    symbolPosition: 'end',
                    data: []
                }, {
                    name: 'bottom',
                    type: 'pictorialBar',
                    symbolSize: [26, 10],
                    symbolOffset: [0, 5],
                    z: 17,
                    itemStyle: {normal: {color: '#55b1fe'}},
                    data: []
                }, {
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: function () {
                                return new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [{
                                        offset: 1,
                                        color: '#54B1FE'
                                    },
                                    {
                                        offset: 0,
                                        color: '#0B73EC'
                                    }
                                    ]
                                );
                            },
                            opacity: 1
                        }
                    },
                    z: 16,
                    silent: true,
                    barWidth: 26,
                    barGap: '-100%',
                    data: []
                }]
            }
        };
    },
    mounted() {
        this.initOptions();
    },
    methods: {
        // 处理options
        initOptions() {
            const _this = this;
            const xAxisData = [];
            _this.echartsData.forEach(item => {
                xAxisData.push(item.name);
            });
            this.options.xAxis.data = xAxisData;
            this.options.series.forEach(item => {
                item.data = _this.echartsData;
            });
        }

    }
};
